import { Component, OnInit, ViewChild } from '@angular/core';
import { IRoomDetails } from 'src/app/models/dashboard.models';
import { ChatMessagesComponent } from './components/chat-messages/chat-messages.component';

@Component({
  selector: 'app-chat-main',
  templateUrl: './chat-main.component.html',
  styleUrls: ['./chat-main.component.scss']
})
export class ChatMainComponent implements OnInit {

  chat: IRoomDetails;
  @ViewChild(ChatMessagesComponent) chatMessage: ChatMessagesComponent;
  LIMIT: number = 15;
  screen: number = 1;

  constructor() { }

  ngOnInit(): void {
  }

  viewChat(roomDetail: IRoomDetails){
    this.chat = roomDetail;
    this.chatMessage.roomDetails = this.chat;
    this.chatMessage.getMessages(this.chat.roomId, this.LIMIT);
    this.screen = 2;
  }

  closeChat(event: any){
    this.screen = 1;
  }

}
